declare global {
	interface Window {
		dataLayer?: unknown[];
		gtag: (...args: unknown[]) => void;
	}
}

export const gtag = (...args: unknown[]): void => {
	if (typeof window !== 'undefined') {
		if (typeof window.gtag === 'undefined') {
			window.dataLayer = window.dataLayer ?? [];
			// oxlint-disable-next-line consistent-function-scoping
			window.gtag = function gtag() {
				window.dataLayer?.push(arguments);
			};
		}

		window.gtag(...args);
	}
};
